/** Notify browse pages to reload catalog after auth changes (sign-in / sign-out). */
type Listener = () => void;
const listeners = new Set<Listener>();

export function subscribeCatalogRefresh(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyCatalogRefresh(): void {
  for (const listener of listeners) {
    listener();
  }
}
